import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AdminDashboard from "@/pages/AdminDashboard";
import BirthdayPage from "@/pages/BirthdayPage";
import AkademiePage from "@/pages/AkademiePage";
import BewerbungPage from "@/pages/BewerbungPage";
import CampsPage from "@/pages/CampsPage";
import CampTeilnahmebedingungenPage from "@/pages/CampTeilnahmebedingungenPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import BookingPage from "@/pages/BookingPage";
import PaketePage from "@/pages/PaketePage";
import MeineRechnungenPage from "@/pages/MeineRechnungenPage";
import MeineTerminePage from "@/pages/MeineTerminePage";
import SmsAbmeldungPage from "@/pages/SmsAbmeldungPage";
import MeineKartePage from "@/pages/MeineKartePage";
import AlternativePage from "@/pages/AlternativePage";
import MobileApp from "@/pages/MobileApp";
import TrainingApp from "@/pages/TrainingApp";

function App() {
  return (
    <HelmetProvider>
      <div className="min-h-screen bg-[#0A0A0A]">
        <div className="noise-overlay" aria-hidden="true" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/geburtstag" element={<BirthdayPage />} />
            <Route path="/akademie" element={<AkademiePage />} />
            <Route path="/bewerbung" element={<BewerbungPage />} />
            <Route path="/camps" element={<CampsPage />} />
            <Route path="/camp-teilnahmebedingungen" element={<CampTeilnahmebedingungenPage />} />
            <Route path="/buchen" element={<BookingPage />} />
            <Route path="/pakete" element={<PaketePage />} />
            <Route path="/meine-rechnungen" element={<MeineRechnungenPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/sms-abmeldung" element={<SmsAbmeldungPage />} />
            <Route path="/meine-karte" element={<MeineKartePage />} />
            <Route path="/meine-termine" element={<MeineTerminePage />} />
            <Route path="/termin-alternative/:token" element={<AlternativePage />} />
            <Route path="/app" element={<MobileApp />} />
            <Route path="/training/*" element={<TrainingApp />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster 
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#1A1A1A',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#FFFFFF',
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
